module.exports = __webpack_public_path__ + "img/one_req_landing_mobile_480.ef6345b7.png";